/**
 * PendingAppointmentsSection - User's pending VIP appointments list
 */

import { Calendar } from 'lucide-react';
import type { Appointment } from '../../../types';

interface PendingAppointmentsSectionProps {
  pendingAppointments: Appointment[];
  onCancelAppointment: (appointmentId: string) => void;
}

export function PendingAppointmentsSection({
  pendingAppointments,
  onCancelAppointment,
}: PendingAppointmentsSectionProps) {
  return (
    <div className="bg-surface border border-hairline rounded-xl p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Calendar className="w-5 h-5 text-ink-subtle" aria-hidden="true" />
        <h2 className="font-sans text-lg font-semibold text-ink">
          Tus Citas Agendadas
        </h2>
      </div>

      <div className="space-y-3">
        {pendingAppointments.map((apt) => {
          const aptDate = apt.dateTime.toDate();
          const isToday = aptDate.toDateString() === new Date().toDateString();

          return (
            <div
              key={apt.appointmentId}
              className={`border rounded-lg p-4 ${
                isToday
                  ? 'border-accent/50 bg-accent/5'
                  : 'border-hairline bg-surface-2'
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    {isToday && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-accent/10 text-accent border border-accent/30">
                        Hoy
                      </span>
                    )}
                    <span className="text-sm text-ink-muted capitalize">
                      {aptDate.toLocaleDateString('es-ES', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                  </div>

                  <p className="font-semibold text-ink text-lg tabular-nums">
                    {aptDate.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
                  </p>

                  <p className="text-sm text-ink-muted mt-1">
                    {apt.serviceName} - {apt.barberName}
                  </p>

                  {isToday && (
                    <p className="text-sm text-accent mt-2 font-medium">
                      Esta cita se convertirá automáticamente en turno hoy
                    </p>
                  )}
                </div>

                {!isToday && (
                  <button
                    onClick={() => onCancelAppointment(apt.appointmentId!)}
                    className="text-ink-subtle hover:text-danger text-sm font-medium transition-colors"
                  >
                    Cancelar
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
